import { render, staticRenderFns } from "./olakkDesktop.vue?vue&type=template&id=09d6452a&scoped=true"
import script from "./olakkDesktop.vue?vue&type=script&lang=js"
export * from "./olakkDesktop.vue?vue&type=script&lang=js"
import style0 from "./olakkDesktop.vue?vue&type=style&index=0&id=09d6452a&prod&lang=less&scoped=true"
import style1 from "./olakkDesktop.vue?vue&type=style&index=1&id=09d6452a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d6452a",
  null
  
)

export default component.exports